import React from "react";
import { useTranslation } from "react-i18next";
import { Clock, Trash2 } from "lucide-react";

interface RecentSearchesProps {
  searches: string[];
  onSelect: (term: string) => void;
  onClear: () => void;
}

export const RecentSearches = React.memo(function RecentSearches({
  searches,
  onSelect,
  onClear,
}: RecentSearchesProps) {
  const { t } = useTranslation();
  if (searches.length === 0) return null;

  return (
    <div className="px-4 py-3">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">
          {t("globalSearch.recentSearches", "Recent Searches")}
        </h3>
        <button
          onClick={onClear}
          className="text-xs text-muted-foreground hover:text-destructive flex items-center gap-1"
          aria-label={t("globalSearch.clearRecent", "Clear recent searches")}
        >
          <Trash2 className="h-3 w-3" />
          {t("globalSearch.clear", "Clear")}
        </button>
      </div>
      <div className="space-y-1">
        {searches.map((term) => (
          <button
            key={term}
            onClick={() => onSelect(term)}
            className="flex items-center gap-2 w-full text-left px-2 py-1.5 rounded-md hover:bg-accent transition-colors text-sm"
          >
            <Clock className="h-3.5 w-3.5 text-muted-foreground shrink-0" />
            <span className="truncate">{term}</span>
          </button>
        ))}
      </div>
    </div>
  );
});
